<template>
  <router-view v-if="!isLayoutDefined" />
  <component
    v-else
    :is="layout"
  />
</template>

<script>
const default_layout = "white"
const available_layouts = ["default", "unauthenticated", "white"]

import DefaultLayout from "@/components/layouts/DefaultLayout.vue"
import UnauthenticatedLayout from "@/components/layouts/UnauthenticatedLayout.vue"
import WhiteLayout from "@/components/layouts/WhiteLayout.vue"

export default {
  components: {
    DefaultLayout,
    UnauthenticatedLayout,
    WhiteLayout
  },
  computed: {
    isLayoutDefined() {
      return !!this.$route.meta.layout
    },
    layout() {
      const name = available_layouts.includes(this.$route.meta.layout)
        ? this.$route.meta.layout
        : default_layout
      return `${name}-layout`
    }
  },
  methods: {},
  mounted() {
    if (this.$store.getters["app/isSignedIn"]) this.$store.dispatch("app/fetchNotifications")
  }
}
</script>
